import aavyaTheme from "@aavya/theme/index";
import $ from "jquery";

export default function () {
    var collection = document.getElementById('collectionMenu');
    var slider = function slider() {
        var arrow = '<svg fill="#000000" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
        return aavyaTheme.slickSlider.create($('#collectionMenu'), {
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            centerMode: true,
            centerPadding: '0px',
            swipeToSlide: true,
            prevArrow: arrow,
            nextArrow: arrow,
            responsive: [{
                breakpoint: 680,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 1024,
                settings: "unslick"
            }]
        });
    };

    if (collection) {
        var $slick = slider();
        $(window).resize(function (e) {
            if (window.innerWidth < 1024) {
                if (!$slick.hasClass('slick-initialized')) {
                    slider();
                }
            }
        });
    }
};
